<template>
  <input
    type="search"
    id="integration-search"
    class="form-control mr-2"
    aria-label="SearchGrid"
    aria-describedby="searchGrid"
    :placeholder="placeholderText"
    v-model="search"
  />

  <!--  <button class="btn btn-outline-remove" type="button" @click="$emit('remove-filter')">
        <i class="fas fa-times-circle"></i>
      </button> -->
</template>

<script>
export default {
  name: 'search',
  props: ['placeholder-text'],
  data: () => ({
    debounceSearch: '',
    timeout: null,
  }),
  methods: {
    addOperator(/* searchedPhrase */) {
      /* console.log('addOperator');
      const matchOrOperator = /\s(?<word>OR|or)\s/g;
      const matchAndOperator = /\s(?<word>AND|and)\s/g;

      let reWriteStr = searchedPhrase.replace(matchOrOperator, ' [OR] ');
      console.log('reWriteStr: ', reWriteStr);
      searchedPhrase = reWriteStr;

      reWriteStr = this.searchedPhrase.replace(matchAndOperator, ' [AND] ');
      searchedPhrase = reWriteStr; */
    },
  },
  computed: {
    search: {
      get() {
        return this.debounceSearch;
      },
      set(val) {
        if (this.timeout) clearTimeout(this.timeout);

        this.timeout = setTimeout(() => {
          this.debounceSearch = val;

          this.$emit('search', this.debounceSearch);
        }, 500);
      },
    },
  },
  watch: {
    debounceSearch: {
      handler(val /* oldVal */) {
        // console.log(`searchText Changed: ${val}`);

        localStorage.mainSearch = val;
      },
    },
  },
  mounted() {
    // Check if there is a old search queries in localStorage
    /* if (this.$route.path.includes('jobs')) {
      if (localStorage.mainSearch) this.search = localStorage.mainSearch;
    } */
  },
};
</script>

<style lang="scss" scoped>
#integration-search {
  border: 1px solid #d7dae2;
  border-radius: 4px;
}

.btn-success {
  display: none;
}

.input-group {
  i {
    display: none;
  }
}

@media only screen and (max-width: 576px) {
  .integration-group {
    min-width: auto !important;
    max-width: 100%;
  }
  .btn-success {
    display: block;
  }
  .btn-outline-remove,
  .btn-outline {
    display: none;
  }
  .input-group {
    position: relative;
    min-width: auto !important;
    max-width: 100%;
    .form-control {
      margin-right: 0 !important;
      padding-left: 35px;
    }
    i {
      position: absolute;
      font-size: 18px;
      top: 10px;
      left: 12px;
      z-index: 99;
      color: #666;
      display: block;
    }
  }
}

.fade-or-operator {
  color: #ccc;
}
</style>
`
